module.exports = __webpack_public_path__ + "static/media/boat-img-25.c698dff5.jpg";